import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor">
    <title></title>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M.875 7a6.125 6.125 0 1 1 12.25 0A6.125 6.125 0 0 1 .875 7M7 .875v1.633M13.125 7h-1.633M7 13.125v-1.633M.875 7h1.633m2.888 0h3.208M7 5.396v3.208"
    />
  </svg>
);

const TargetIcon = (props) => <Icon component={SVG} {...props} />;

export default TargetIcon;
